import { TemplateConfig } from "@/interfaces/editor";
import { Project } from "@/shared/sync/dataTypes/Project";
import { createAction } from "@reduxjs/toolkit";

export const saveDraft = createAction<Project>("drafts/saveDraft");
export const updateDraft = createAction<Project>("drafts/updateDraft");
export const removeDraft = createAction<string>("drafts/removeDraft");
export const clearDrafts = createAction("drafts/clearDrafts");
export const duplicateDraft = createAction<Project>("drafts/duplicateDraft");
export const createDraft = createAction<string>("drafts/createDraft");
export const createDraftFromTemplateConfig = createAction<TemplateConfig>(
    "drafts/createDraftFromTemplateConfig"
);
